// extracted by mini-css-extract-plugin
export default {"temporary":"Temporary_temporary__CAVFI"};